import { GET_LOGS } from 'actions/types';
import { transformActions } from 'utils/';

const initialState = {
  data: [],
  isLoading: false,
};

/**
  @description Stores logs array details in redux state
  @param {[]} state
  @param {{}} action
  @returns {[]}
 */
function logs(state = initialState, action) {
  const { type, payload } = action;
  const actions = [GET_LOGS];
  const success = transformActions(actions, 'SUCCESS');
  const failure = transformActions(actions, 'FAILURE');

  if (type === GET_LOGS) {
    return {
      data: [],
      isLoading: true,
    };
  }

  if (success.includes(type)) {
    return {
      data: payload,
      isLoading: false,
    };
  }

  if (failure.includes(type)) {
    return {
      data: [],
      isLoading: false,
    };
  }

  return state;
}

export default logs;
